import { useRef, useState } from 'react'

export function useIsTyping(): { isTyping: boolean; setIsTyping: (isTyping: boolean, timeout?: number) => () => void } {
  const [isTyping, setIsTyping] = useState(false)
  const lastTypingHeartbeatRef = useRef<Date | null>(null)

  return {
    isTyping,
    setIsTyping: (isTyping: boolean, timeout?: number) => {
      setIsTyping(isTyping)
      if (!isTyping) {
        return () => {}
      }
      lastTypingHeartbeatRef.current = new Date()
      if (!timeout) {
        return () => {}
      }
      const timeoutId = setTimeout(() => {
        const lastHeartbeat = lastTypingHeartbeatRef.current
        if (lastHeartbeat && new Date().getTime() - lastHeartbeat.getTime() > timeout) {
          setIsTyping(false)
        }
      }, timeout + 100)

      return () => clearTimeout(timeoutId)
    },
  }
}
